import {
  MARKER_DEFAULT_SHADOW,
  MARKER_DELIVERED_COLOR,
  MARKER_DRIVER_BORDER_COLOR,
  MARKER_DRIVER_COLOR,
  MARKER_DRIVER_GLYPH_COLOR,
  MARKER_HIGHLIGHT_SHADOW,
  MARKER_ORIGIN_BORDER_COLOR,
  MARKER_ORIGIN_COLOR,
  MARKER_ORIGIN_GLYPH_COLOR,
  MARKER_SELECTED_COLOR,
} from './delivery-route-map-model'
import { getDeliveryRouteMapMarkerTone } from './delivery-route-map-markers'

export function applyMarkerElementTone(
  element,
  {
    bucket,
    handledState,
    isBlocked,
    isHighlighted = false,
    isPartiallySelected,
    isReadOnlyRoute,
    isSelected,
  }
) {
  const tone = getDeliveryRouteMapMarkerTone({
    bucket,
    handledState,
    isBlocked,
    isPartiallySelected,
    isReadOnlyRoute,
    isSelected,
  })

  element.style.border = `2px solid ${tone.border}`
  element.style.background = tone.background
  element.style.color = tone.glyph
  element.style.opacity = isBlocked ? '0.55' : '1'
  element.style.boxShadow = isHighlighted ? MARKER_HIGHLIGHT_SHADOW : MARKER_DEFAULT_SHADOW
  element.style.animation = isHighlighted
    ? 'delivery-route-marker-attention 850ms ease-out infinite'
    : ''
}

export function getClassicMarkerStyle({
  circlePath,
  handledState,
  isBlocked,
  isPartiallySelected,
  isReadOnlyRoute,
  isSelected,
  label,
}) {
  const tone = getDeliveryRouteMapMarkerTone({
    handledState,
    isBlocked,
    isPartiallySelected,
    isReadOnlyRoute,
    isSelected,
  })
  let fallbackFillColor = tone.background
  if (handledState === 'handled' || handledState === 'mixed') {
    fallbackFillColor = MARKER_DELIVERED_COLOR
  } else if (isPartiallySelected) {
    fallbackFillColor = MARKER_SELECTED_COLOR
  }

  return {
    icon: circlePath
      ? {
          path: circlePath,
          scale: 11,
          fillColor: fallbackFillColor,
          fillOpacity: isBlocked ? 0.55 : 1,
          strokeColor: tone.border,
          strokeWeight: 2,
        }
      : null,
    label: label ? { text: label, color: tone.glyph } : null,
  }
}

export function applyClassicMarkerStyle(mapMarker, markerStyle) {
  if (markerStyle.icon) {
    mapMarker.setIcon?.(markerStyle.icon)
  }

  if (markerStyle.label) {
    mapMarker.setLabel?.(markerStyle.label)
  }
}

export function buildMarkerElement({
  ariaLabel,
  bucket,
  handledState,
  isBlocked,
  isPartiallySelected,
  isReadOnlyRoute,
  isSelected,
  label,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) {
  const element = document.createElement('button')

  element.type = 'button'
  element.className = 'delivery-route-map-marker'
  element.setAttribute('aria-label', ariaLabel ?? label)
  element.title = ariaLabel ?? label
  element.style.width = '34px'
  element.style.height = '34px'
  element.style.borderRadius = '999px'
  element.style.fontSize = '13px'
  element.style.fontWeight = '700'
  element.textContent = label
  applyMarkerElementTone(element, {
    bucket,
    handledState,
    isBlocked,
    isPartiallySelected,
    isReadOnlyRoute,
    isSelected,
  })
  element.addEventListener('click', (event) => {
    event.stopPropagation()
    onClick?.()
  })
  element.addEventListener('pointerenter', () => onMouseEnter?.())
  element.addEventListener('pointerleave', () => onMouseLeave?.())
  element.addEventListener('focus', () => onMouseEnter?.())
  element.addEventListener('blur', () => onMouseLeave?.())

  return element
}

export function buildOriginMarkerElement({ ariaLabel }) {
  const element = document.createElement('div')

  element.className = 'delivery-route-map-origin-marker'
  element.setAttribute('aria-label', ariaLabel)
  element.setAttribute('role', 'img')
  element.style.alignItems = 'center'
  element.style.background = MARKER_ORIGIN_COLOR
  element.style.border = `2px solid ${MARKER_ORIGIN_BORDER_COLOR}`
  element.style.borderRadius = '999px'
  element.style.boxShadow = '0 8px 18px rgb(15 23 42 / 0.2)'
  element.style.color = MARKER_ORIGIN_GLYPH_COLOR
  element.style.display = 'flex'
  element.style.fontSize = '13px'
  element.style.fontWeight = '800'
  element.style.height = '32px'
  element.style.justifyContent = 'center'
  element.style.width = '32px'
  element.textContent = 'F'

  return element
}

export function buildDriverMarkerElement({ ariaLabel }) {
  const element = document.createElement('div')

  element.className = 'delivery-route-map-driver-marker'
  element.setAttribute('aria-label', ariaLabel)
  element.setAttribute('role', 'img')
  element.style.alignItems = 'center'
  element.style.background = MARKER_DRIVER_COLOR
  element.style.border = `2px solid ${MARKER_DRIVER_BORDER_COLOR}`
  element.style.borderRadius = '999px'
  element.style.boxShadow = '0 8px 18px rgb(15 23 42 / 0.24)'
  element.style.color = MARKER_DRIVER_GLYPH_COLOR
  element.style.display = 'flex'
  element.style.fontSize = '13px'
  element.style.fontWeight = '800'
  element.style.height = '34px'
  element.style.justifyContent = 'center'
  element.style.width = '34px'
  element.textContent = 'D'

  return element
}
